class ViewRules {
    static CREATE = new ViewRules(0, true, true);
    static UPDATE = new ViewRules(1, false, true);
    static READONLY = new ViewRules(2, false, false);

    constructor(id, create, update) {
        this._id = id;
        this._create = create;
        this._update = update
    }

    get id() {
        return this._id;
    }

    get create() {
        return this._create;
    }

    get update() {
        return this._update;
    }

    equal(rule) {
        return this._id === rule._id;
    }

    clone() {
        let copy = new ViewRules();
        copy._id = this._id;
        copy._create = this._create;
        copy._update = this._update;
        return copy;
    }
}

export default ViewRules;

